import React, { useState } from 'react';
import { useVideo } from '../../../contexts/VideoContext';
import './Steps.css';

const EMOTIONS = [
  { value: 'happy', label: 'Happy', emoji: '😊', description: 'Cheerful and content' },
  { value: 'excited', label: 'Excited', emoji: '🤩', description: 'Full of energy!' },
  { value: 'playful', label: 'Playful', emoji: '😄', description: 'Ready to play' },
  { value: 'tired', label: 'Tired', emoji: '😴', description: 'Worn out from fun' },
  { value: 'silly', label: 'Silly', emoji: '🤪', description: 'Goofy and fun' },
  { value: 'relaxed', label: 'Relaxed', emoji: '😌', description: 'Calm and peaceful' },
  { value: 'curious', label: 'Curious', emoji: '🤔', description: 'Exploring everything' },
  { value: 'proud', label: 'Proud', emoji: '😎', description: 'Accomplished something' },
];

const Step3Emotion = () => {
  const { videoData, updateVideoData, nextStep, prevStep } = useVideo();
  const [selectedEmotion, setSelectedEmotion] = useState(videoData.emotion || '');
  const [error, setError] = useState('');

  const handleEmotionSelect = (emotion) => {
    setSelectedEmotion(emotion);
    setError('');
  };

  const handleNext = () => {
    if (!selectedEmotion) {
      setError('Please select an emotion');
      return;
    }

    updateVideoData({ emotion: selectedEmotion });
    nextStep();
  };

  return (
    <div className="wizard-step">
      <div className="step-content">
        <div className="step-icon">🎭</div>
        <h2 className="step-title">How is {videoData.petName} Feeling?</h2>
        <p className="step-description">
          Choose the emotion for your pet's video
        </p>

        <div className="emotion-grid">
          {EMOTIONS.map((emotion) => (
            <button
              key={emotion.value}
              type="button"
              className={`emotion-card ${
                selectedEmotion === emotion.value ? 'selected' : ''
              }`}
              onClick={() => handleEmotionSelect(emotion.value)}
            >
              <span className="emotion-emoji">{emotion.emoji}</span>
              <h3 className="emotion-label">{emotion.label}</h3>
              <p className="emotion-description">{emotion.description}</p>
            </button>
          ))}
        </div>

        {error && <div className="error-message">{error}</div>}

        {/* Navigation */}
        <div className="step-navigation">
          <button type="button" className="btn-secondary" onClick={prevStep}>
            <span className="btn-icon">←</span>
            Back
          </button>
          <button type="button" className="btn-primary" onClick={handleNext}>
            Next Step
            <span className="btn-icon">→</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step3Emotion;
